import { useEffect } from 'react';

/* Wires the CSS scroll-reveal system (.reveal-hidden → .reveal-visible in
   index.css): one IntersectionObserver over every [data-reveal] element,
   adding the visible class once and unobserving. Elements keep whatever
   variant classes they carry (.reveal-wipe for the pen-stroke eyebrows,
   plain for the ink fade-rise) and can stagger via inline transitionDelay. */
export default function useRevealObserver() {
  useEffect(() => {
    const els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            io.unobserve(entry.target);
          }
        });
      },
      /* Huge top margin: anything at or above the viewport counts as seen,
         so instant jumps (End key, anchor links) can't strand sections in
         their hidden state — only content still below the fold waits. */
      { threshold: 0, rootMargin: '10000px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
